document.addEventListener('DOMContentLoaded', function() {
  // Nav scroll
  var nav = document.getElementById('site-nav');
  if (nav) {
    window.addEventListener('scroll', function() {
      nav.classList.toggle('scrolled', window.scrollY > 50);
    });
  }

  // Reveal on scroll
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) e.target.classList.add('visible');
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });
  document.querySelectorAll('.reveal').forEach(function(el) { obs.observe(el); });

  // Cart quantity + remove handled by cart-ajax.js (async, delegated)

  // Collection filter pills
  document.querySelectorAll('.filter-pill').forEach(function(pill) {
    pill.addEventListener('click', function() {
      document.querySelectorAll('.filter-pill').forEach(function(p) { p.classList.remove('active'); p.setAttribute('aria-pressed','false'); });
      this.classList.add('active');
      this.setAttribute('aria-pressed','true');
      var filter = this.dataset.filter;
      document.querySelectorAll('.c-card').forEach(function(card) {
        if (filter === 'all' || card.dataset.type === filter) {
          card.style.display = 'block';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });

  // Product page variant pills
  document.querySelectorAll('.option-pills .pill').forEach(function(pill) {
    pill.addEventListener('click', function() {
      this.parentElement.querySelectorAll('.pill').forEach(function(p) { p.classList.remove('selected'); p.setAttribute('aria-pressed','false'); });
      this.classList.add('selected');
      this.setAttribute('aria-pressed','true');
    });
  });

  // Product gallery thumbs handled by product-form.js (variant-aware crossfade)

  // Sticky mobile CTA (product page)
  if (window.innerWidth <= 768) {
    var addBtn = document.getElementById('addToCart');
    var sticky = document.getElementById('stickyCta');
    if (addBtn && sticky) {
      new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          sticky.style.transform = e.isIntersecting ? 'translateY(100%)' : 'translateY(0)';
          sticky.style.transition = 'transform 0.3s ease';
        });
      }, { threshold: 0 }).observe(addBtn);
    }
  }
});
